import React, { Component } from 'react';
import { Form, InputNumber, Button, Row, Col, Select, message, Input } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/correction';

class Correction extends Component {
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 8,
            span: 16,
        },
    };
    onFinish = async (values) => {
        await this.props.onSubmit({ agentId: values.agent, amount: values.amount, description: values.description },
            this.props.token);
        if (this.props.message) {
            message.success(this.props.message);
        }
        if (this.props.error) {
            message.error(this.props.error);
        }
    };

    onFinishFailed = (errorInfo) => {

    };
    render() {
        let { Option } = Select;
        const agents = this.props.agents.map(agent => {
            return (
                <Option key={agent.id} value={agent.id}>{agent.name}</Option>
            );
        });
        return <>
            <Row justify="left" align="middle">
                <Col lg={8} sm={20}>
                    <h1 style={{ marginLeft: '100px', fontSize: '24px' }}>Correction Form</h1>
                    <Form
                        {...this.layout}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Form.Item
                            label="Agent"
                            name="agent"
                            rules={[
                                {
                                    required: true,
                                    message: 'Select agent',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                style={{ width: 180 }}
                            >
                                {agents}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Amount"
                            name="amount"
                            rules={[
                                {
                                    required: true,
                                    message: 'Require',
                                },
                            ]}
                        >
                            <InputNumber
                                style={{ width: 180 }}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} />
                        </Form.Item>
                        <Form.Item
                            label="description"
                            name="description"
                            rules={[
                                {
                                    required: true,
                                    message: 'Require',
                                },
                            ]}
                        >
                            <Input placeholder="description" />
                        </Form.Item>
                        <Form.Item
                            {...this.tailLayout}
                        >
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </>
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        error: state.correction.error,
        message: state.correction.message,
        agents: state.agents.agents,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onSubmit: (request, token) => dispatch(actions.correction(request, token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Correction);